import { Entypo } from "@expo/vector-icons";
import Chip from "components/Chip";
import Input from "components/Input";
import { EventType } from "features/types";
import React from "react";
import { Pressable, ScrollView, View } from "react-native";

interface Props {
  size: number;
  selectedPartySize: number;
  minPartySize?: number;
  onChange: (newPartySize: number) => void;
  variant?: "chip" | "ticker";
  eventType?: EventType;
}

const getUnitLabel = (eventType?: EventType): string => {
  if (eventType === "PARKING") return "Space";
  if (eventType === "RSVP") return "Guest";
  return "Seat";
};

const SeatQuantitySelector: React.FC<Props> = (props) => {
  const {
    size,
    selectedPartySize,
    onChange,
    variant = "chip",
    minPartySize = 1,
    eventType,
  } = props;

  const arrayWithPredefinedSize = Array.from(
    { length: size - minPartySize + 1 },
    (_, i) => i + minPartySize
  );

  const handleTicketChange = (newPartySize: number) => {
    if (newPartySize < minPartySize || newPartySize > size) return;
    onChange(newPartySize);
  };

  if (variant === "chip") {
    return (
      <ScrollView
        horizontal
        contentContainerStyle={{
          alignItems: "center",
          padding: 10,
        }}
        showsHorizontalScrollIndicator={true}
      >
        {/* https://github.com/FanRally/fanrally-core/issues/1560 */}
        {arrayWithPredefinedSize.map((el) => {
          return (
            <Pressable
              key={el}
              style={{ marginRight: 5 }}
              testID="number-of-seat-chip"
            >
              <Chip
                selected={selectedPartySize === el}
                onPress={() => onChange(el)}
              >
                {el}{" "}
                {`${getUnitLabel(eventType)}${el === 1 ? "" : "s"}`}
              </Chip>
            </Pressable>
          );
        })}
      </ScrollView>
    );
  }

  return (
    <View className="flex-row items-center gap-2">
      <Pressable onPress={() => handleTicketChange(selectedPartySize - 1)}>
        <Entypo name="minus" size={24} color="black" />
      </Pressable>
      <Input style={{ width: 50 }} value={selectedPartySize.toString()} />
      <Pressable onPress={() => handleTicketChange(selectedPartySize + 1)}>
        <Entypo name="plus" size={24} color="black" />
      </Pressable>
    </View>
    // <Select
    //   size="small"
    //   onSelect={(index) => {
    //     const row = (index as IndexPath).row;
    //     onChange(row + 1);
    //   }}
    //   selectedIndex={new IndexPath(selectedPartySize - 1)}
    //   value={selectedPartySize.toString()}
    //   style={{ alignSelf: "flex-start" }}
    // >
    //   {arrayWithPredefinedSize.map((_, index) => {
    //     return <SelectItem key={index} title={index + 1} />;
    //   })}
    // </Select>
  );
};

export default SeatQuantitySelector;
